module.exports = __webpack_public_path__ + "img/report_building.d90b2eb6.svg";